
import { Capacitor, Plugins } from '@capacitor/core';
import { mapGetters, mapMutations, mapActions } from 'vuex';
const { Device } = Plugins;
const { LocalNotifications } = Plugins;
const { PushNotifications } = Plugins;
import { format } from 'date-fns';
import HowToInvoiceModal from './HowToInvoiceModal.vue';

export default {
  components: { HowToInvoiceModal },
    head () {
        return {
            title: this.seoTitle,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.seoDescription
                },
                {
                    hid: 'og:title',
                    name: 'og:title',
                    content: this.seoTitle
                },
                {
                    hid: 'og:description',
                    name: 'og:description',
                    content: this.seoDescription
                },
            ]
        }
    },
    created(){
        this.addListenerDeviceToken();
    },
    transition(to, from) {
        return 'page-reverse';
    },
    data: () => ({
        scrollY: 0,
        selectedMenuItem: 'pickup',
        showUpdateAppMessage: false,
        userWatcher: null,
        showInviteFriendsModal: false,
        timeOfDayToggle: {
            morgenmad: false,
            frokost: false,
            aftensmad: false
        },
        sharedMeals: null,
        searchText: '',
        toggledFoodCategories: []
    }),
    props: {
        // timeCategories: { type: Object, required: true },
        // disableTimeBasedMechanics: {type: Boolean, required: true},
        // disableCategories: {type: Boolean, required: false, default: false}
        concept: {type: String, required: false},
    },
    computed: {
        ...mapGetters(['loggedInUser']),
        ...mapGetters('restaurants', ['restaurants', 'categories']),
        ...mapGetters('location', ['location']),
        ...mapGetters('order', ['isDelivery', 'address']),
        searchParams() {
            return {
                location: this.location,
            };
        },
        showAddressPicker() {
            return this.isDelivery && this.address;
        },
        showUserLocationPicker() {
            return !this.isDelivery;
        },
        activeOrdersLength() {
            if (this.loggedInUser) {
                return this.loggedInUser.orders.filter(x => x.state === 'confirmed' || x.state === 'placed' || x.state === 'delivery-ongoing').length;
            }
            return 0;
        },
        badgeText() {
            return this.activeOrdersLength ? this.activeOrdersLength.toString() : null;
        },
        hasAddresses() {
            return this.loggedInUser && this.loggedInUser.addresses.length;
        },
        isNative() {
            return Capacitor.isNative;
        },
        platform(){
            return Capacitor.getPlatform();
        },
        firstname() {
            return this.loggedInUser ? this.loggedInUser.name.split(' ')[0] : '';
        },
        ordersCount() {
            return this.loggedInUser ? this.loggedInUser.orders_count : 0;
        },
        newUser() {
            return this.loggedInUser ? this.loggedInUser.new_user : false;
        },
        profileBtnText() {
            return this.loggedInUser && this.loggedInUser.name ? this.loggedInUser.name.split(' ')[0] : 'Profil';
        },
        theLocation() {
            if (this.location) {
                return this.location;
            }
            return null;
        },
        seoTitle () {
            return 'Tribe - Bestil  Takeaway - Vi deler et måltid, når du bestiller'
        },
        seoDescription () {
            return 'Få den lækreste mad leveret hurtigt til din dør. Bredt udvalg af byen bedste restauranter. Tribe er et socialt ansvarligt takeaway koncept, der skal være med til at stoppe sult i verden!'
        },
        welcomeHeadline() {
            let text = 'Hej,<br>'
            let hour = format(new Date(), 'H');
            if (hour > 17) {
                text = 'God aften,<br>'
            } else if (hour > 11) {
                text = 'God eftermiddag,<br>'
            } else if (hour > 8) {
                text = 'God formiddag,<br>'
            } else {
                text = 'God morgen,<br>'
            }
            if (this.loggedInUser) {
                if (this.loggedInUser.name) {
                    text += ` ${this.loggedInUser.name.split(' ')[0]}`
                }
            }
            return text
        },
        categoriesAvailable(){
            let categories = Object.keys(this.timeOfDayToggle)
            let available = {};
            if (this.restaurants && this.restaurants.length){
                categories = categories.filter(c =>
                    this.restaurants.find(r => r.categories.find(cr => cr.slug === c))
                )
                Object.keys(this.timeOfDayToggle).forEach(c => {
                    available[c] = categories.includes(c)
                })
            }
            else {
                categories.forEach(c => available[c] = false)
            }
            return available;
        },
        userImpactScore() {
            if (this.loggedInUser) {
                return this.loggedInUser.impact_score.user;
            }
            return 0;
        },
        userMealsUntilNextDeliveryToken() {
            if (this.loggedInUser) {
                let impactScore = this.loggedInUser.impact_score.user;
                let inThisPeriod = impactScore - (Math.floor(impactScore / 10) * 10);
                return 10 - inThisPeriod;
            }
            return 0;
        },
        featuredCategories(){
            if (this.categories){
                return this.categories.filter(c => c.featured)
            }
        },

    },
    activated() {
        if (this.loggedInUser) {
            this.$auth.fetchUser();
        }
        if (this.$el && this.scrollY) {
            this.$el.scrollTo(0, this.scrollY);
        } else {
            this.$el.scrollTo(0, 0);
        }
        // setInterval(() => {
        this.guessLocation();
        // }, 2500);
        if (this.isNative) {
            this.checkForLatestAppVersion();
        }
        this.checkAddress();
        this.handleGroupCartURL();
        this.searchText = '';

        /* const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        let category = urlParams.get('category');
        if(category && !this.disableTimeBasedMechanics){
            this.setDefaultTimeOfDay();
        } */
    },
    deactivated() {
        const { scrollTop } = this.$el;
        this.scrollY = scrollTop;
    },
    mounted() {
        this.getSharedMeals();
        this.checkForNotifications();
        this.userWatcher = this.$watch('$store.getters.loggedInUser', (newVal, OldVal) => {
            if (newVal){
                this.checkForNotifications()
                //Unwatch for performance
                this.userWatcher();
            }
        });
        /*if (this.loggedInUser) {
            this.$auth.fetchUser();
        }*/
        this.handleInviteCodeURL();
        this.handleInviteFriendsURL();
        // this.timeOfDayToggle = this.timeCategories;
    },
    methods: {
        ...mapMutations('sheet', ['setSheet']),
        ...mapActions('toast', ['setToast']),
        ...mapMutations('modal', ['setModal']),
        ...mapMutations('order', ['clearAddress', 'setAddress', 'setDeliveryMethod', 'setGroupCartSlave', 'setGroupCartUUID']),
        ...mapActions('order', ['changeDeliveryMethod']),
        ...mapActions('location', ['getLocation']),
        ...mapMutations('location', ['setLocation', 'clearLocation']),
        openHowToInvoiceSheet () {
            this.setSheet({ type: 'HowToInvoice' });
        },
        async checkForLatestAppVersion() {
            this.showUpdateAppMessage = false;
            let info = await Device.getInfo();
            let userAppVersion = info.appVersion;
            this.$axios.get(`/latest-app-store-version?version=${userAppVersion}`)
                .then((response) => {
                    let userOnNewestVersion = response.data.user_on_newest_version;
                    if (!userOnNewestVersion) {
                        this.showUpdateAppMessage = true;
                    }
                }, (err) => {
                    console.log(err);
                })
        },
        openAppStore() {
            window.location = 'https://apps.apple.com/dk/app/tribe-takeaway/id1545333058';
        },
        openGooglePlay(){
            window.location = 'https://play.google.com/store/apps/details?id=com.tribetakeaway2.app';
        },
        nativeStoreUrl(){
            if (this.platform === 'android'){
                return this.openGooglePlay();
            }
            else{
                return this.openAppStore();
            }
        },
        openAddressModal() {
            if (this.hasAddresses) {
                this.setModal({ type: 'AddressPick' });
            } else {
                this.setModal({ type: 'AddressCheck' });
            }
        },
        resetStateAddress() {
            this.clearAddress();
            this.changeDeliveryMethod({ method: 'pickup' });
        },
        async doGetLocation() {
            await this.getLocation();
        },
        setTestLocation() {
            const location = {
                latitude: 55.0000,
                longitude: 12.0000,
            };
            this.setLocation(location);
        },
        guessLocation() {
            /* if (this.location && !this.address) {
                const lat = this.location.latitude;
                const lng = this.location.longitude;
                const url = 'https://api.dataforsyningen.dk/adgangsadresser/reverse';
                const params = {
                    y: lat,
                    x: lng,
                };
                this.$axios.get(url, {params})
                    .then((response) => {
                        // console.log('response', response);
                        if (response.data.adressebetegnelse) {
                            // this.searchInput = response.data.adressebetegnelse;
                            const addressUrl = 'https://dawa.aws.dk/autocomplete?q=' + response.data.adressebetegnelse + '&type=adresse&caretpos=15&supplerendebynavn=true&stormodtagerpostnumre=true&multilinje=true&fuzzy=';
                            this.$axios.get(addressUrl)
                                .then((addressResponse) => {
                                    // console.log('addressResponse', addressResponse);
                                    if (addressResponse.data.length) {
                                        const selected = addressResponse.data[0];
                                        const result = {
                                            address: selected.tekst.substring(0, selected.tekst.lastIndexOf(',')),
                                            lat: selected.data.y,
                                            lng: selected.data.x,
                                            postal: selected.data.postnr,
                                            city: selected.data.postnrnavn,
                                            dawa_uuid: selected.data.id,
                                        };
                                        this.selectAddressFromCoordinates(result);
                                        this.setDeliveryMethod('delivery');
                                        // console.log('result', result);
                                    }
                                })
                                .catch((error) => {
                                    console.error('error', error);
                                })
                        }
                    })
                    .catch((err) => {
                        console.error('err', err);
                    })
            } */
        },
        selectAddressFromCoordinates(address) {
            /* const location = {
                latitude: address.lat,
                longitude: address.lng,
            }; */
            // this.setLocation(location);
            this.setAddress(address);
            // this.setDeliveryMethod('delivery');
            // await this.$nextTick();
            // this.$refs.sheet.animateOut();
        },
        requestNotificationPermission () {
            LocalNotifications.requestPermission()
                .then((result) => {
                    if(result){
                        PushNotifications.register();
                    }
                })
        },
        checkForNotifications(){
            if(this.isNative && this.loggedInUser){
                LocalNotifications.areEnabled()
                    .then((result) => {
                        if (!result.value) {
                            this.requestNotificationPermission()
                        }
                        else {
                            PushNotifications.register();
                        }
                    })
            }
        },
        addListenerDeviceToken () {
            if (this.isNative) {
                PushNotifications.addListener('registration', (token) => {
                    try {
                        this.$axios.post(`/user-device-token`, {'device_token': token.value});
                    } catch (error) {
                        this.$bugsnag.notify(new Error(error));
                    }
                });
                PushNotifications.addListener('registrationError', (error) => {
                    this.$bugsnag.notify(new Error(error));
                });
            }
        },
        handleInviteCodeURL(){
            let inviteCode = this.$route.query.invite_code;
            let isMobileView = window.innerWidth < 769;
            if (inviteCode && !this.loggedInUser){
                if (isMobileView){
                    this.$router.push(`/login?invite_code=${inviteCode}`);
                }
                else {
                    this.setModal({ type: 'NewLogin', data: {inviteCode: inviteCode} });
                }
            }
            else if(inviteCode && this.loggedInUser){
                if(isMobileView){
                    return this.setToast({ msg: 'Invitationskode er kun for nye brugere', duration: 3 });
                }
                else {
                    setTimeout(() => {
                        alert("Invitationskode er kun for nye brugere");
                    }, 1000);

                }
            }
        },
        handleInviteFriendsURL() {
            let inviteFriendsParam = this.$route.query.invite_friends;
            let isMobileView = window.innerWidth < 769;
            if (inviteFriendsParam) {
                if (isMobileView){
                    this.$router.push(`/posts/invite`);
                }
                else {
                    this.showInviteFriendsModal = true;
                }
            }
        },
        async handleGroupCartURL(){
            const groupCartUUID = this.$route.query.group_uuid;
            if (groupCartUUID){
                try {
                    const { data } = await this.$axios.get(`/group-cart/find?uuid=${groupCartUUID}`);
                    this.setGroupCartUUID(groupCartUUID)
                    if (this.loggedInUser && this.loggedInUser.id === data.user_id){
                        this.setGroupCartSlave(false)
                    }
                    else {
                        this.setGroupCartSlave(true)
                    }
                    this.$router.push(`/supplier/${data.restaurant_location_slug}`)
                }
                catch (error){
                    this.$bugsnag.notify(new Error(error));
                    this.setToast({ });
                }
            }
            else {
                this.setGroupCartSlave(false)
                this.setGroupCartUUID(null)
            }
        },
        checkAddress(){
            if (this.isDelivery && !this.address){
                // this.setSheet({ type: 'Address' })
            }
        },
        async getSharedMeals() {
            try {
                const {data} = await this.$axios.get('/shared-meals');
                this.sharedMeals = data;
            } catch (error) {
                this.$bugsnag.notify(new Error(error));
                console.log({ error });
            }
        },
        setDefaultTimeOfDay() {
            this.timeOfDayToggle.morgenmad = true;
            this.timeOfDayToggle.frokost = true;
            this.timeOfDayToggle.aftensmad = true;

            // Overrule default if forced category
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            let category = urlParams.get('category');
            if (category){
                this.timeOfDayToggle.morgenmad = false;
                this.timeOfDayToggle.frokost = false;
                this.timeOfDayToggle.aftensmad = false;
                switch (category){
                    case 'morgenmad':
                        this.timeOfDayToggle.morgenmad = true;
                        break;
                    case 'frokost':
                        this.timeOfDayToggle.frokost = true;
                        break;
                    case 'aftensmad':
                        this.timeOfDayToggle.aftensmad = true;
                        break;
                    default:
                        this.timeOfDayToggle.morgenmad = true;
                        this.timeOfDayToggle.frokost = true;
                        this.timeOfDayToggle.aftensmad = true;

                }
            }
            /* const now = new Date();
            const currentHour = now.getHours();
            if (currentHour >= 0 && currentHour <= 10 && this.categoriesAvailable.morgenmad) {
                this.timeOfDayToggle.morgenmad = true;
            } else if (currentHour < 12 && this.categoriesAvailable.frokost) {
                this.timeOfDayToggle.frokost = true;
            } else if (this.categoriesAvailable.aftensmad) {
                this.timeOfDayToggle.aftensmad = true;
            } */
        },
        openUserModal() {
            this.setModal({ type: 'User' });
        },
        toggleTimeOfDay(type) {
            if (this.timeOfDayToggle.morgenmad && this.timeOfDayToggle.frokost && this.timeOfDayToggle.aftensmad) {
                this.timeOfDayToggle.morgenmad = false;
                this.timeOfDayToggle.frokost = false;
                this.timeOfDayToggle.aftensmad = false;
                this.timeOfDayToggle[type] = true;
            } else {
                this.timeOfDayToggle[type] = !this.timeOfDayToggle[type];
            }
        },
        toggleFoodCategory(slug){
            if (this.toggledFoodCategories.includes(slug)){
                const index = this.toggledFoodCategories.findIndex(c => c === slug);
                if (index !== -1){
                    this.toggledFoodCategories.splice(index, 1)
                }
            } else {
                this.toggledFoodCategories.push(slug)
            }
        }
    },
    watch: {
        isDelivery(){
            this.checkAddress();
        },
        'location': 'guessLocation',
        categoriesAvailable: {
            handler() {
                if (!this.disableTimeBasedMechanics){
                    this.setDefaultTimeOfDay();
                }
            },
            deep: true,
        },
    }
};
